import { render } from "./FadeCarousel.vue?vue&type=template&id=b8b66a08&scoped=true"
import script from "./FadeCarousel.vue?vue&type=script&lang=js"
export * from "./FadeCarousel.vue?vue&type=script&lang=js"

import "./FadeCarousel.vue?vue&type=style&index=0&id=b8b66a08&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b66a08"]])

export default __exports__